
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import axios from "@/axios-instance"

export default defineComponent({
  name: "modalChooseMajor",
  emits:["callBackFunc"],
  props: {
    // arrMajor: Array as any,
    id: String,
    title: String,
  },
  methods: {
    changeAdMajor() {
      let record = this.arrMajor.find((i)=> i.code == this.formData.admissionmajorcode)
      if(record) {
        this.formData.admissionmajorname = record.name
        this.formData.admissionmajorshortname = record.shortname
      }
    },
    showModal() {
        this.call_modal.click()
    },
    closeModal(){
        this.formData = {
          admissionmajorcode: '',
          admissionmajorname: '',
          admissionmajorshortname: '',
          scholarshipregistration: '',
          school: '',
        }
        hideModal(this.addChooseApp)
    },
    async submitComment() {
      
      this.$emit("callBackFunc",this.formData)
      hideModal(this.addChooseApp)
    },
  },
  async mounted() {
    // console.log('title', this.title)
    await axios.get(`/major`,)
    .then(async({ data }) => {
      this.arrMajor = data
    })
    .catch((error) => {
      console.log('err', error)
    });
    await axios.get(`/setting/scholarship_public/find/findall`,)
    .then(async({ data }) => {
      this.arrScholarship = data
    })
    .catch((error) => {
      console.log('err', error)
    });
    
  },
  setup() {
    const addChooseApp = ref<null | HTMLElement>(null);
    const call_modal = ref<any>();
    const formData = ref<any>({
      admissionmajorcode: '',
      admissionmajorname: '',
      admissionmajorshortname: '',
      scholarshipregistration: '',
      school: '',
    });
    const arrMajor = ref<any>([]);
    const arrScholarship = ref<any>([]);
      
    const admissionwinnerid = ref('')
    const arrSchool = ref([{
      value: 'Khoa Công nghệ',
      label: 'Khoa Công nghệ'
    },
    {
      value: 'Khoa Truyền thông và Nghệ thuật ứng dụng',
      label: 'Khoa Truyền thông và Nghệ thuật ứng dụng'
    },
    {
      value: 'Khoa Xây dựng',
      label: 'Khoa Xây dựng'
    },
    {
      value: 'Khoa Kinh doanh',
      label: 'Khoa Kinh doanh'
    },
    {
      value: 'Khoa Thiết kế và Nghệ thuật',
      label: 'Khoa Thiết kế và Nghệ thuật'
    },
    {
      value: 'Viện Khoa học và Quản lý Thể dục Thể thao',
      label: 'Viện Khoa học và Quản lý Thể dục Thể thao'
    },
    ])
    
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return {
        call_modal,
        addChooseApp,
        admissionwinnerid,
        formData,
        arrSchool,
        arrMajor,
        arrScholarship,
        user
    };
  },
});
